<template>
	<div class="app-section_block" v-loading="loading">
		<div
			class="app-label pointer"
			v-for="(item, index) in tableData"
			:key="index"
		>
			<div class="app-icon">
				<el-image :src="require('@images/icon/calender.png')" />
				<div
					class="tc"
					style="line-height: 1.5;"
					v-if="icon && (item.state === '兑现中' || item.state === '未开始')"
				>
					距离{{ item.state === "兑现中" ? "申报截止" : "申报开始" }}<br />
					还剩
					<span class="app-gap">
						{{ item.gapDay }}
					</span>
					天
				</div>
				<div v-else>
					<span class="app-state dead">{{ item.state }}</span>
				</div>
			</div>
			<div class="app-text">
				<div class="app-title ellipsis">{{ item[propers.title] }}</div>
				<div
					v-html="item[propers.content]"
					class="app-content next-ellipsis"
					v-if="item[propers.content]"
				></div>
				<div class="app-footer">
					<div class="app-nature">
						<i class="el-icon-tag"></i>
						性质: {{ item[propers.nature] }}
					</div>
					<div class="app-branch">
						<i class="el-icon-tag"></i>
						发布部门: {{ item[propers.branch] }}
					</div>
<!-- 					<div class="app-pageView">
						<i class="el-icon-tag"></i>
						浏览量: {{ item[propers.pageView] }}{{ pageViewUnit }}
					</div> -->
				</div>
			</div>
		</div>
		<div v-if="tableData.length === 0 && !loading" class="app-loading">
			<div class="lack m_t30">
				<img style="height: 100px;" src="@images/center/recom.png" alt="" />
				<div style="text-align: center; margin-top: 20px;">无匹配政策</div>
			</div>
		</div>
	</div>
</template>
<script lang="js">
import { pageViewUnit } from '@/config';
export default {
	name: "CalendarSection",
  data() {
    return {
      pageViewUnit
    }
  },
	props: {
		loading: {
			type: Boolean,
			required: false,
			default() {
				return false;
			}
		},
		tableData: {
			type: Array,
			required: true,
			default() {
				return [];
			}
		},
		icon: {
			type: Boolean,
			required: false,
			default() {
				return true;
			}
		},
		name: {
			type: String,
			default: "qjDescribe"
		},
		propers: {
			type: Object,
			required: true,
			default() {
				return {
					title: "title",
					branch: "branch",
					date: "date",
					content: "content",
					nature: "nature",
					pageView: "pageView"
				};
			}
		}
	},
	methods: {
		to(id) {
			this.$router.push({
				name: this.name,
				params: {
					id,
					did: "undefined"
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/components/table.scss';
$iconSize: 130px;
.app-label {
  height: $iconSize;
  margin-top: 16px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.app-title {
  font-size: 16px;
  font-weight: bolder;
}
.app-content {
  font-size: 16px;
  margin-top: 0px;
}
.app-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  color: #aaa;
}
.app-icon {
  width: $iconSize;
  height: $iconSize;
  background: rgba(skyblue, 0.1);
  line-height: 1;
  margin-right: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $black;
  &.border {
    border: 1px dotted #ccc;
    font-size: 16px;
    line-height: 1.5;
  }
  .el-image {
    width: 40px;
    margin-bottom: 10px;
    // margin: 10px 0;
  }
}
.app-text {
  width: calc(100% - 224px);
}
.app-gap {
  color: $blue;
}
.app-gap, .app-state {
}
.app-state.dead {
  color:  $red;
}
</style>
